import { useEffect, useRef, useState } from 'react';
import io from 'socket.io-client';

const SERVER_URL = process.env.REACT_APP_KOYEB_URI;

export default function RadioListen(){
  const audioRef = useRef(null);
  const sbRef = useRef(null);
  const queueRef = useRef([]);
  const msRef = useRef(null);
  const [status, setStatus] = useState('OFF AIR');

  const destroyPlayer = () => {
    const audio = audioRef.current;
    if(!audio) return;
    try{ audio.pause(); }catch{}
    try{ 
      if(msRef.current && msRef.current.readyState === 'open'){
        msRef.current.endOfStream();
      }
    }catch{}
    if(audio.src) {
      try{ URL.revokeObjectURL(audio.src); }catch{}
      audio.removeAttribute('src');
      audio.load();
    }
    sbRef.current = null;
    msRef.current = null;
    queueRef.current = [];
  };

  const createPlayer = () => {
    destroyPlayer();
    const audio = audioRef.current;
    const ms = new MediaSource();
    msRef.current = ms;
    audio.src = URL.createObjectURL(ms);
    
    ms.addEventListener('sourceopen', () => {
      try{
        const sb = ms.addSourceBuffer('audio/webm; codecs=opus');
        sbRef.current = sb;
        sb.addEventListener('updateend', () => {
          if(queueRef.current.length>0 && !sb.updating){
            sb.appendBuffer(queueRef.current.shift());
          }
        });
      }catch(e){ console.log(e); }
    });
  };

  useEffect(()=>{
    const socket = io(SERVER_URL, { transports: ['websocket','polling'] });
    createPlayer();

    socket.on('radio:status', s => {
      if(s.isOnAir){
        setStatus('● EN VIVO - dale PLAY');
        if(!msRef.current || msRef.current.readyState !== 'open'){
          createPlayer();
        }
      } else {
        setStatus('OFF AIR');
        destroyPlayer();
        createPlayer();
      }
    });

    socket.on('radio:force-stop', () => {
      setStatus('Cortado - esperando...');
      destroyPlayer();
      createPlayer();
    });

    socket.on('radio:stream', async d => {
      let buf = d instanceof Blob? await d.arrayBuffer() : d?.data? new Uint8Array(d.data).buffer : d;
      if(!buf || !sbRef.current) return;
      if(sbRef.current.updating || queueRef.current.length>0){
        queueRef.current.push(buf);
      } else {
        try{ sbRef.current.appendBuffer(buf); }
        catch{ queueRef.current.push(buf); }
      }
    });

    return ()=> {
      socket.disconnect();
      destroyPlayer();
    }
  },[]);

  const handlePlay = async () => {
    const audio = audioRef.current;
    if(!audio) return;
    try{
      // Esperamos a que termine cualquier play anterior
      await audio.play();
      setStatus('● EN VIVO');
    }catch(e){
      // Si lo interrumpe, no hacemos nada, es normal
      if(e.name !== 'AbortError'){
        setStatus('Dale PLAY de nuevo');
        console.log(e);
      }
    }
  };

  return (
    <div style={{padding:20}}>
      <p><b>{status}</b></p>
      <audio ref={audioRef} controls preload="none" />
      <br/>
      <button onClick={handlePlay} style={{marginTop:10, padding:'15px 30px', background:'#60469E', color:'#fff', border:'none', borderRadius:10, fontWeight:900}}>
        ▶ PLAY
      </button>
    </div>
  )
}